const EmptyListView = ({ icon, tagLineOne, tagLineTwo, tagHeight }) => {
    return (
        <>
            <div style={{ height: tagHeight }}>
                <div className="d-flex flex-grow-* flex-column align-items-center justify-content-center h-100">
                    <div className={icon}></div>
                    <div className="d-flex flex-column align-items-center">
                        <span className="hs-fs-16 hs-color-dark-grey mt-1">{tagLineOne}</span>
                        <span className="hs-fs-12 hs-text-muted mt-1">{tagLineTwo}</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmptyListView;
